import { SingleButton, SingleButtonContainer } from './EachCourse.styles';
import Auth from '../../Helpers/auth';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import React, { Suspense, useState } from 'react';
import { httpAddToCart } from '../../Hooks/user/user.post.hooks';
import UserHomeDataProvider from '../../Utils/Users/UserHomeDataProvider';

const PurchaseCourseButton = ({ id }) => {
  const { data } = Auth.getProfile();
  const queryClient = useQueryClient();
  const [status, setStatus] = useState('');

  const mutation = useMutation({
    mutationFn: ({ courseId, userId }) => httpAddToCart(courseId, userId),
    onSuccess: async (data) => {
      setStatus(data.message || 'Course added to cart');
      console.log(data.message || 'Course added to cart');
      queryClient.invalidateQueries(['cart']);
    },
    onError: async (error) => {
      setStatus(error.message || 'Failed to add course');
      console.error('Error adding course:', error);
      alert('Failed to add the course to the cart. Please try again.');
    },
    retry: 3,
  });

  const handleAddToCart = () => {
    if (!data?.id) {
      alert('User ID is missing. Please log in again.');
      return;
    }
    mutation.mutate({ courseId: id, userId: data.id });
  };

  return (
    <>
      <SingleButtonContainer>
        <UserHomeDataProvider showLoading={false}>
          {(user) => (
            <>
              <SingleButton>
                <p>{status}</p>
                {Auth.loggedIn() ? (
                  <>
                    <Suspense fallback={<div>Loading Button...</div>}>
                      <PrimaryButtonComponent
                        span={mutation.isLoading ? 'Adding...' : 'Add to cart'}
                        functionName={handleAddToCart}
                        disabled={mutation.isLoading}
                      />
                    </Suspense>
                    {user?.courses?.some((c) => c?.courseId === id) && (
                      <p className="italicSpan m1T">
                        You have already registered for this course
                      </p>
                    )}
                  </>
                ) : (
                  <p>Sign in to purchase a course</p>
                )}
              </SingleButton>
            </>
          )}
        </UserHomeDataProvider>
      </SingleButtonContainer>
    </>
  );
};

PurchaseCourseButton.propTypes = {
  id: PropTypes.string,
};

export default PurchaseCourseButton;
